import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// components
import { Text } from './..'

// hooks
import { useFullListingData, getListingZipcode } from '../../hooks/listing'

// Utils
import { useBranding } from '../../hooks/branding'

// Assets
import styles from './LenderStats.module.scss'

const LenderStats = ({ center }) => {
  const { address } = useFullListingData() ?? {}
  const zip = getListingZipcode(address)

  const { loClientsHelped, loYearsInIndustry } = useBranding()

  const statsPresent = loClientsHelped || loYearsInIndustry

  if (!statsPresent) return null

  return (
    <div className={styles.highlights}>
      {loClientsHelped && (
        <div>
          <Text
            size='xl'
            color='eggShell'
            className={classnames(center && styles.center)}
          >
            {loClientsHelped}
          </Text>
          <Text
            size='s'
            className={styles.stats}
          >{`clients helped in ${zip}`}</Text>
        </div>
      )}
      {loYearsInIndustry && (
        <div>
          <Text
            size='xl'
            color='eggShell'
            className={classnames(center && styles.center)}
          >
            {loYearsInIndustry}
          </Text>
          <Text size='s' className={styles.stats}>
            {loYearsInIndustry === 1 ? 'year' : 'years'} in the industry
          </Text>
        </div>
      )}
    </div>
  )
}

LenderStats.propTypes = {
  center: PropTypes.bool,
}

export default LenderStats
